import { networkLogos } from './networkLogos'
import { ratePlanCodes } from './ratePlanCode'

export const PlanTypes = {
  CHICAGO_SPORTS_NETWORK: 'chicago_sports_network',
  ROOT_SPORTS_NETWORK: 'root_sports_network',
  MASN_PLUS: 'masn_plus',
  RANGERS_SPORTS_NETWORK: 'rangers_sports_network',
  MARQUEE: 'marquee_sports_network',
}

export const PlanData = {
  [PlanTypes.CHICAGO_SPORTS_NETWORK]: {
    rsn: ['Chicago Sports Network'],
    name: 'Chicago Sports Network',
    title: 'Chicago Sports Network',
    plan: 'chicago_sports_network',
    teams: ['Chicago Bulls', 'Chicago Blackhawks', 'Chicago White Sox'],
    price: 29.99,
    discountedPrice: 24.99,
    networkLogos: [
      {
        logo: networkLogos.chsn.logoWhite,
        alt: 'CHSN',
        width: 100,
        height: 48,
      },
    ],
  },
  [PlanTypes.ROOT_SPORTS_NETWORK]: {
    rsn: ['Root Sports Network'],
    teams: ['Seattle Mariners'],
  },
  [PlanTypes.RANGERS_SPORTS_NETWORK]: {
    rsn: ['Rangers Sports Network'],
    teams: ['Texas Rangers'],
    name: 'Rangers Sports Network',
    price: 20,
    discountedPrice: 15,
    networkLogos: [
      {
        logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/networks/rangers_sports_network-red-logo.png',
        alt: 'Rangers Sports Network',
        width: 100,
        height: 48,
      },
    ],
  },
  [PlanTypes.MASN_PLUS]: {
    name: 'MASN+',
    rsn: ['MASN+'],
    title: 'MASN+',
    plan: 'masn_plus',
    teams: ['Baltimore Orioles', 'Washington Nationals'],
    price: 19.99,
    discountedPrice: 14.99,
    latinoBundlePromoCode: ratePlanCodes.latino_masn_plus,
    latinoBundlePrice: 32.99,
    latinoBundleDiscountedPrice: 24.99,
    disableFreeTrial: true,
    networkLogos: [
      {
        logo: networkLogos.masn.logoWhite,
        alt: 'MASN',
        width: 85,
        height: 48,
      },
    ],
  },
  [PlanTypes.MARQUEE]: {
    rsn: ['Marquee Sports Network'],
    teams: ['Chicago Cubs', 'Sky', 'Red Stars'],
  },
}
